import { UPDATE_FEIERTAGSKONTO_EINSTELLUNGEN } from '@/domain/mitarbeiter/features/feiertagskonto/hooks/useUpdateFeiertagskontoEinstellungen/graphql/mutations';
import { Mitarbeiter_UpdateFeiertagskontoEinstellungenMutationVariables } from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useUpdateFeiertagskontoEinstellungen() {
  const [update, result] = useMutation(UPDATE_FEIERTAGSKONTO_EINSTELLUNGEN, {
    refetchQueries: ['mitarbeiter_getFeiertagskonto'],
    awaitRefetchQueries: true,
  });
  const updateFeiertagskontoEinstellungen = useCallback(
    (
      variables: Mitarbeiter_UpdateFeiertagskontoEinstellungenMutationVariables,
    ) => {
      return update({ variables });
    },
    [update],
  );
  if (!result) {
    throw new Error('Fehler beim updaten der FeiertagskontoEinstellungen.');
  }
  return [updateFeiertagskontoEinstellungen] as const;
}
